import { Component } from '@angular/core';
import {
    ParametersService,
    SubtitlesService,
    ZoneScheduleService,
    ZonesService
} from "../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'zone-schedule-select',
    templateUrl: './zone-schedule-select.component.html',
    styleUrls: ['./zone-schedule-select.component.scss']
})
export class ZoneScheduleSelectComponent {
    constructor(
        // public database: DatabaseService,
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
        // public views: ViewsService,
        public zones: ZonesService,
        public zoneSchedule: ZoneScheduleService,
    ) {
    }
    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }

        this.zones.setOverflow();
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }
}
